import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster as Sonner } from "sonner";
import { AuthProvider } from "@/hooks/useAuth";
import { ThemeProvider } from "@/hooks/useTheme";

import Index from "./pages/Index";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import NotFound from "./pages/NotFound";
import Extension from "./pages/Extension";
import ExtensionThankYou from "./pages/ExtensionThankYou";
import HostedSite from "./pages/HostedSite";
import SiteAnalytics from "./pages/SiteAnalytics";

import DashboardLayout from "./components/dashboard/DashboardLayout";
import { dashboardRoutes } from "./routes/dashboardRoutes";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/extension" element={<Extension />} />
                <Route path="/extension/thank-you" element={<ExtensionThankYou />} />

                {/* Hosted sites (public, outside dashboard) */}
                <Route path="/s/:slug" element={<HostedSite />} />
                <Route path="/site-analytics" element={<SiteAnalytics />} />

                <Route path="/dashboard" element={<DashboardLayout />}>
                  {dashboardRoutes}
                </Route>

                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
            <Toaster />
            <Sonner />
          </AuthProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
